import { useEffect } from 'react';
import { Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuthStore } from '../store/auth';

/**
 * 钉钉 PC OAuth 回调：login.dingtalk.com 重定向到此页，携带 authCode 或 code。
 * 与钉钉开放平台「登录第三方网站」里配置的回调 URL 必须完全一致。
 */
export function DingtalkCallbackPage() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((s) => s.setAuth);

  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const authCode = q.get('authCode') || q.get('code');
    const err = q.get('error_description') || q.get('error');

    const goLogin = (msgText?: string) => {
      if (msgText) message.error(msgText);
      navigate('/login', { replace: true });
    };

    if (err) {
      goLogin(typeof err === 'string' ? err : '钉钉授权失败');
      return;
    }
    if (!authCode) {
      goLogin('未获取到授权码，请重试扫码');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const r: any = await api.post('/auth/dingtalk/h5', { authCode });
        if (cancelled) return;
        setAuth(r.accessToken, r.profile);
        message.success(`欢迎，${r.profile.name}`);
        navigate('/', { replace: true });
      } catch (e: any) {
        if (!cancelled) goLogin(e?.message || '钉钉登录失败');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate, setAuth]);

  return (
    <div style={{ padding: 100, textAlign: 'center' }}>
      <Spin size="large" tip="钉钉授权中…" />
    </div>
  );
}
